// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_TournamentGridEditor__3RdVW{
    display: grid;
    grid-template-columns: 6fr 6fr;
    height: 800px;
    background: blue;
}
.styles_LeftHemiScreen__NF5cI{
    background: aquamarine;
}
.styles_RightHemiScreen__EbrXo{
    background: antiquewhite;
}

.styles_TournamentGreedCard__QAZFX {
    position: relative;
    width: 410px;
    /*height: 165px;*/
    flex-shrink: 0;
    border-radius: 15px;
    background: #FFF;
    box-shadow: 0 0 15px 0 rgba(0, 0, 0, 0.15);
    display: grid;
    grid-template-rows: 1.3fr 0.2fr 1.3fr;
    /* grid-template-rows: 1.5fr 0.5fr 1.5fr; */
    /*max-height: 200px;*/
    border: 1px solid rgba(0, 0, 0, 0);
    padding: 20px;
}

.styles_SheduleMark__Q3alJ {
    max-width: max-content;
    max-height: 30px;
    cursor: pointer;
    position: absolute;
    right: 30px;
    top: 10px;
    display: flex;
}

.styles_ChangeTime__pmpFk {
    width: 18px;
    height: 18px;
    margin-left: 5px;
    color: black;
    filter: hue-rotate(70deg);
}

.styles_ChangeTimeActive__ttxfO {
    filter: none;
}

.styles_DropIcon__1FATn {
    position: absolute;
    bottom: 10px;
    left: 10px;
}

.styles_RemoveIcon__dXHgT{
    width: 15px;
    height: 15px;
}

.styles_OpenScheduler__Fz1n9{
    position: absolute;
    width: 100%;
}

.styles_SheduleMark__Q3alJ > img {
    max-width: 24px;
    max-height: 24px;
}

.styles_Selectable__d7ljz:hover{
    box-shadow: 0 0 15px 0 rgba(41, 127, 176, 0.15);
}

.styles_Selected__9AlWa{
    box-shadow: 0 0 15px 0 rgba(41, 127, 176, 0.7);
}

.styles_TournamentGreedCardLine__DEOou{
    display: grid;
    grid-template-columns: 3fr 2fr 3fr;
}
.styles_TeamPlayerLine__PCX\\+t{
    display: flex;
    flex-direction: row;
    font-family: Inter;
    font-size: 11px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px; /* 200% */
    text-transform: uppercase;
    min-width: 150px;
}

.styles_PlayerName__8WhQu{
    padding-left: 10px; 
    cursor: default;
}

.styles_TeamLine__86UV\\+{
    display: flex;
    padding: 10px;
    flex-direction: column;
    justify-content: center;
    /*background: #297FB0;*/
}

.styles_AchievementIcons__8QSAo{
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
}

.styles_DividerLine__IYZ7H{
    display: grid;
    grid-template-columns: 3fr 2fr 3fr;
}

.styles_DividerEnumeration__25ygB{
    display: flex;
    justify-content: center;
    color: #297FB0;
    font-family: Inter, serif;
    font-size: 9px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px; /* 200% */
    text-transform: uppercase;
    justify-content: center;
    align-items: center;
    width: 130px;
}

.styles_Scores__nre00{
    display: flex;
    flex-direction: row;
    color: #297FB0;
    font-family: Inter, serif;
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px; /* 200% */
    text-transform: uppercase;
    justify-content: center;
    align-items: center;
    width: 91px;
}
.styles_ScoreNumber__FSUa2{
    position: relative;
    padding: 8px;
    cursor: default;
}

.styles_TieBreak__\\+FRun{
    position: absolute;
    right: 0;
    top: 0;
}
.styles_DividerContainer__55pSY{
    display: grid;
    grid-template-rows: 1fr 1fr;
}
.styles_DividerContainer__55pSY > div:first-child {
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}
.styles_CardEditMenu__PdcAM{
    position: absolute;
    display: flex;
    flex-direction: row;
    justify-content: center;
    width: 110px;
    right: -110px;
}
.styles_PlayerEditionPanel__oHN2u{
    position: absolute;
    display: flex;
    flex-direction: row;
    justify-content: center;
    width: 110px;
    height: 130px;
    right: -110px;
    top: 30px;
    border: 1px solid rgb(162, 143, 143, 0.0);
}

.styles_SelectedElement__Vc-QT, .styles_SelectableElement__ebYBC:hover{
    /*border: 1px solid rgb(162, 143, 143, 0.1);*/
    background: rgba(230, 230, 230, 0.7);
    border-radius: 8px;
    /*filter: blur(8px);*/
}

.styles_SelectableElement__ebYBC .styles_PlayerName__8WhQu:hover{
    border-bottom: 1px solid rgb(162, 143, 143, 0.8);
}

.styles_TopLineScoreEditor__Niiqd, .styles_BottomLineScoreEditor__Osw-n{
    position: absolute;
    right: 20px;
}

.styles_TopLineScoreEditor__Niiqd{
    top: -10px;
}

.styles_BottomLineScoreEditor__Osw-n{
    bottom: -10px;
}
.styles_OnlineIndicator__-sZ5e {
    position: absolute;
    padding: 3px;
    font-size: 12px;
    cursor: pointer;
}
.styles_operatorId__xzrgr{
    position: absolute;
    display: flex;
    justify-content: end;
    width: 90%;
    font-size: 12px;
    bottom: 22px
}

.styles_matchId__jR7qe{
    position: absolute;
    display: flex;
    justify-content: end;
    width: 90%;
    font-size: 12px;
}

.styles_InputsId__IzpXK {
    position: relative;
    display: flex;
    flex-direction: column;
    left: 30px;
    z-index: 10;
    align-self: end;
    gap: 4px
}

.styles_InputsId__IzpXK div{
    width: 0;
    display: flex;
    flex-direction: row;
}

.styles_containerCart__rYkY3{
    position: relative;
    display: flex;
    flex-direction: row;
}

.styles_responseMessage__fW8Ao{
    top: 34%;
    position: absolute;
    display: flex;
    flex-direction: row;
}

.styles_DateTime__nb1y1::-webkit-datetime-edit {
    display: none;
}

.styles_DateTime__nb1y1 {
    border: 0;
}

@-moz-document url-prefix(){
  .styles_SheduleMark__Q3alJ {
    max-width: 190px!important;
  }
}

.styles_Ret__0dVqM {
    opacity: 0.5;
    font-family: Inter, serif;
    color: #606060;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
}

.styles_RetActive__PrG05 {
    opacity: 1;
}

.styles_NumberMatch__kLbN8 {
    width: 30px;
    margin-right: 10px;
    margin-left: 5px;
    text-align: center;
}

.styles_InputsPlayers__aa7Fb {
    height: 186px;
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    left: -490px;
    gap: 30px; 
}

.styles_ChangeStartMatch__TDAe\\+ {
    position: absolute;
    display: flex;
    flex-direction: row;
    left: 440px;
    z-index: 11;
}

.styles_AddPlayer__yLZOw {
    height: 20px;
    width: max-content;
    cursor: pointer;
    -webkit-user-select: none;
            user-select: none;
    font-size: 12px;
    padding: 0px 10px;
    border: 1px solid rgb(49, 49, 251);
    color: rgb(49, 49, 251);
    border-radius: 12px;
}

.styles_AddPlayer__yLZOw:hover {
    background-color: rgba(0, 0, 0, 0.185);
}

.styles_PlayerList__IHFUK {
    position: absolute;
    z-index: 100;
    left: 430px;
    height: 450px;

    padding: 10px;
    background-color: white;
    border: 1px solid rgb(49, 49, 251);
    border-radius: 12px;

    display: flex;
    flex-direction: column;
    justify-content: start;
    align-items: end;
    gap: 10px;

    >div:nth-child(1) {
        width: max-content;
        height: max-content;

        cursor: pointer;
        -webkit-user-select: none;
                user-select: none;
        padding: 0px 10px;
        border: 1px solid rgb(49, 49, 251);
        color: rgb(49, 49, 251);
        border-radius: 12px;
    }

    >div:nth-child(1):hover {
        background-color: rgba(0, 0, 0, 0.185);
    }

    >div:nth-child(2) {
        overflow: auto;
    }
}

@media (max-width: 768px) {
    .styles_TournamentGreedCard__QAZFX {
        width: 100vw;
    }
    .styles_containerCart__rYkY3 {
        margin-left: 0px;
    }
        .styles_PlayerList__IHFUK {
        left: calc(100vw + 20px);
    }
}`, "",{"version":3,"sources":["webpack://./src/widgets/tournament/tournament-double-card/styles.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,8BAA8B;IAC9B,aAAa;IACb,gBAAgB;AACpB;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,wBAAwB;AAC5B;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,iBAAiB;IACjB,cAAc;IACd,mBAAmB;IACnB,gBAAgB;IAChB,0CAA0C;IAC1C,aAAa;IACb,qCAAqC;IACrC,2CAA2C;IAC3C,qBAAqB;IACrB,kCAAkC;IAClC,aAAa;AACjB;;AAEA;IACI,sBAAsB;IACtB,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,UAAU;AACd;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,+CAA+C;AACnD;;AAEA;IACI,8CAA8C;AAClD;;AAEA;IACI,aAAa;IACb,kCAAkC;AACtC;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB,EAAE,SAAS;IAC5B,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,kCAAkC;AACtC;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,cAAc;IACd,yBAAyB;IACzB,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB,EAAE,SAAS;IAC5B,yBAAyB;IACzB,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,cAAc;IACd,yBAAyB;IACzB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB,EAAE,SAAS;IAC5B,yBAAyB;IACzB,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;AACf;AACA;IACI,kBAAkB;IAClB,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,MAAM;AACV;AACA;IACI,aAAa;IACb,2BAA2B;AAC/B;AACA;IACI,2CAA2C;AAC/C;AACA;IACI,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,aAAa;AACjB;AACA;IACI,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,aAAa;IACb,aAAa;IACb,SAAS;IACT,yCAAyC;AAC7C;;AAEA;IACI,6CAA6C;IAC7C,oCAAoC;IACpC,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,gDAAgD;AACpD;;AAEA;IACI,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,aAAa;AACjB;AACA;IACI,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,eAAe;AACnB;AACA;IACI,kBAAkB;IAClB,aAAa;IACb,oBAAoB;IACpB,UAAU;IACV,eAAe;IACf;AACJ;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,oBAAoB;IACpB,UAAU;IACV,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,UAAU;IACV,WAAW;IACX,eAAe;IACf;AACJ;;AAEA;IACI,QAAQ;IACR,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,QAAQ;IACR,kBAAkB;IAClB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,SAAS;AACb;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;IACI,YAAY;IACZ,yBAAyB;IACzB,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,YAAY;IACZ,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,yBAAiB;YAAjB,iBAAiB;IACjB,eAAe;IACf,iBAAiB;IACjB,kCAAkC;IAClC,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,aAAa;;IAEb,aAAa;IACb,uBAAuB;IACvB,kCAAkC;IAClC,mBAAmB;;IAEnB,aAAa;IACb,sBAAsB;IACtB,sBAAsB;IACtB,gBAAgB;IAChB,SAAS;;IAET;QACI,kBAAkB;QAClB,mBAAmB;;QAEnB,eAAe;QACf,yBAAiB;gBAAjB,iBAAiB;QACjB,iBAAiB;QACjB,kCAAkC;QAClC,uBAAuB;QACvB,mBAAmB;IACvB;;IAEA;QACI,sCAAsC;IAC1C;;IAEA;QACI,cAAc;IAClB;AACJ;;AAEA;IACI;QACI,YAAY;IAChB;IACA;QACI,gBAAgB;IACpB;QACI;QACA,wBAAwB;IAC5B;AACJ","sourcesContent":[".TournamentGridEditor{\n    display: grid;\n    grid-template-columns: 6fr 6fr;\n    height: 800px;\n    background: blue;\n}\n.LeftHemiScreen{\n    background: aquamarine;\n}\n.RightHemiScreen{\n    background: antiquewhite;\n}\n\n.TournamentGreedCard {\n    position: relative;\n    width: 410px;\n    /*height: 165px;*/\n    flex-shrink: 0;\n    border-radius: 15px;\n    background: #FFF;\n    box-shadow: 0 0 15px 0 rgba(0, 0, 0, 0.15);\n    display: grid;\n    grid-template-rows: 1.3fr 0.2fr 1.3fr;\n    /* grid-template-rows: 1.5fr 0.5fr 1.5fr; */\n    /*max-height: 200px;*/\n    border: 1px solid rgba(0, 0, 0, 0);\n    padding: 20px;\n}\n\n.SheduleMark {\n    max-width: max-content;\n    max-height: 30px;\n    cursor: pointer;\n    position: absolute;\n    right: 30px;\n    top: 10px;\n    display: flex;\n}\n\n.ChangeTime {\n    width: 18px;\n    height: 18px;\n    margin-left: 5px;\n    color: black;\n    filter: hue-rotate(70deg);\n}\n\n.ChangeTimeActive {\n    filter: none;\n}\n\n.DropIcon {\n    position: absolute;\n    bottom: 10px;\n    left: 10px;\n}\n\n.RemoveIcon{\n    width: 15px;\n    height: 15px;\n}\n\n.OpenScheduler{\n    position: absolute;\n    width: 100%;\n}\n\n.SheduleMark > img {\n    max-width: 24px;\n    max-height: 24px;\n}\n\n.Selectable:hover{\n    box-shadow: 0 0 15px 0 rgba(41, 127, 176, 0.15);\n}\n\n.Selected{\n    box-shadow: 0 0 15px 0 rgba(41, 127, 176, 0.7);\n}\n\n.TournamentGreedCardLine{\n    display: grid;\n    grid-template-columns: 3fr 2fr 3fr;\n}\n.TeamPlayerLine{\n    display: flex;\n    flex-direction: row;\n    font-family: Inter;\n    font-size: 11px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 24px; /* 200% */\n    text-transform: uppercase;\n    min-width: 150px;\n}\n\n.PlayerName{\n    padding-left: 10px; \n    cursor: default;\n}\n\n.TeamLine{\n    display: flex;\n    padding: 10px;\n    flex-direction: column;\n    justify-content: center;\n    /*background: #297FB0;*/\n}\n\n.AchievementIcons{\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    cursor: pointer;\n}\n\n.DividerLine{\n    display: grid;\n    grid-template-columns: 3fr 2fr 3fr;\n}\n\n.DividerEnumeration{\n    display: flex;\n    justify-content: center;\n    color: #297FB0;\n    font-family: Inter, serif;\n    font-size: 9px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 24px; /* 200% */\n    text-transform: uppercase;\n    justify-content: center;\n    align-items: center;\n    width: 130px;\n}\n\n.Scores{\n    display: flex;\n    flex-direction: row;\n    color: #297FB0;\n    font-family: Inter, serif;\n    font-size: 12px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 24px; /* 200% */\n    text-transform: uppercase;\n    justify-content: center;\n    align-items: center;\n    width: 91px;\n}\n.ScoreNumber{\n    position: relative;\n    padding: 8px;\n    cursor: default;\n}\n\n.TieBreak{\n    position: absolute;\n    right: 0;\n    top: 0;\n}\n.DividerContainer{\n    display: grid;\n    grid-template-rows: 1fr 1fr;\n}\n.DividerContainer > div:first-child {\n    border-bottom: 1px solid rgba(0, 0, 0, 0.1);\n}\n.CardEditMenu{\n    position: absolute;\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n    width: 110px;\n    right: -110px;\n}\n.PlayerEditionPanel{\n    position: absolute;\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n    width: 110px;\n    height: 130px;\n    right: -110px;\n    top: 30px;\n    border: 1px solid rgb(162, 143, 143, 0.0);\n}\n\n.SelectedElement, .SelectableElement:hover{\n    /*border: 1px solid rgb(162, 143, 143, 0.1);*/\n    background: rgba(230, 230, 230, 0.7);\n    border-radius: 8px;\n    /*filter: blur(8px);*/\n}\n\n.SelectableElement .PlayerName:hover{\n    border-bottom: 1px solid rgb(162, 143, 143, 0.8);\n}\n\n.TopLineScoreEditor, .BottomLineScoreEditor{\n    position: absolute;\n    right: 20px;\n}\n\n.TopLineScoreEditor{\n    top: -10px;\n}\n\n.BottomLineScoreEditor{\n    bottom: -10px;\n}\n.OnlineIndicator {\n    position: absolute;\n    padding: 3px;\n    font-size: 12px;\n    cursor: pointer;\n}\n.operatorId{\n    position: absolute;\n    display: flex;\n    justify-content: end;\n    width: 90%;\n    font-size: 12px;\n    bottom: 22px\n}\n\n.matchId{\n    position: absolute;\n    display: flex;\n    justify-content: end;\n    width: 90%;\n    font-size: 12px;\n}\n\n.InputsId {\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    left: 30px;\n    z-index: 10;\n    align-self: end;\n    gap: 4px\n}\n\n.InputsId div{\n    width: 0;\n    display: flex;\n    flex-direction: row;\n}\n\n.containerCart{\n    position: relative;\n    display: flex;\n    flex-direction: row;\n}\n\n.responseMessage{\n    top: 34%;\n    position: absolute;\n    display: flex;\n    flex-direction: row;\n}\n\n.DateTime::-webkit-datetime-edit {\n    display: none;\n}\n\n.DateTime {\n    border: 0;\n}\n\n@-moz-document url-prefix(){\n  .SheduleMark {\n    max-width: 190px!important;\n  }\n}\n\n.Ret {\n    opacity: 0.5;\n    font-family: Inter, serif;\n    color: #606060;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: normal;\n}\n\n.RetActive {\n    opacity: 1;\n}\n\n.NumberMatch {\n    width: 30px;\n    margin-right: 10px;\n    margin-left: 5px;\n    text-align: center;\n}\n\n.InputsPlayers {\n    height: 186px;\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    left: -490px;\n    gap: 30px; \n}\n\n.ChangeStartMatch {\n    position: absolute;\n    display: flex;\n    flex-direction: row;\n    left: 440px;\n    z-index: 11;\n}\n\n.AddPlayer {\n    height: 20px;\n    width: max-content;\n    cursor: pointer;\n    user-select: none;\n    font-size: 12px;\n    padding: 0px 10px;\n    border: 1px solid rgb(49, 49, 251);\n    color: rgb(49, 49, 251);\n    border-radius: 12px;\n}\n\n.AddPlayer:hover {\n    background-color: rgba(0, 0, 0, 0.185);\n}\n\n.PlayerList {\n    position: absolute;\n    z-index: 100;\n    left: 430px;\n    height: 450px;\n\n    padding: 10px;\n    background-color: white;\n    border: 1px solid rgb(49, 49, 251);\n    border-radius: 12px;\n\n    display: flex;\n    flex-direction: column;\n    justify-content: start;\n    align-items: end;\n    gap: 10px;\n\n    >div:nth-child(1) {\n        width: max-content;\n        height: max-content;\n\n        cursor: pointer;\n        user-select: none;\n        padding: 0px 10px;\n        border: 1px solid rgb(49, 49, 251);\n        color: rgb(49, 49, 251);\n        border-radius: 12px;\n    }\n\n    >div:nth-child(1):hover {\n        background-color: rgba(0, 0, 0, 0.185);\n    }\n\n    >div:nth-child(2) {\n        overflow: auto;\n    }\n}\n\n@media (max-width: 768px) {\n    .TournamentGreedCard {\n        width: 100vw;\n    }\n    .containerCart {\n        margin-left: 0px;\n    }\n        .PlayerList {\n        left: calc(100vw + 20px);\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"TournamentGridEditor": `styles_TournamentGridEditor__3RdVW`,
	"LeftHemiScreen": `styles_LeftHemiScreen__NF5cI`,
	"RightHemiScreen": `styles_RightHemiScreen__EbrXo`,
	"TournamentGreedCard": `styles_TournamentGreedCard__QAZFX`,
	"SheduleMark": `styles_SheduleMark__Q3alJ`,
	"ChangeTime": `styles_ChangeTime__pmpFk`,
	"ChangeTimeActive": `styles_ChangeTimeActive__ttxfO`,
	"DropIcon": `styles_DropIcon__1FATn`,
	"RemoveIcon": `styles_RemoveIcon__dXHgT`,
	"OpenScheduler": `styles_OpenScheduler__Fz1n9`,
	"Selectable": `styles_Selectable__d7ljz`,
	"Selected": `styles_Selected__9AlWa`,
	"TournamentGreedCardLine": `styles_TournamentGreedCardLine__DEOou`,
	"TeamPlayerLine": `styles_TeamPlayerLine__PCX+t`,
	"PlayerName": `styles_PlayerName__8WhQu`,
	"TeamLine": `styles_TeamLine__86UV+`,
	"AchievementIcons": `styles_AchievementIcons__8QSAo`,
	"DividerLine": `styles_DividerLine__IYZ7H`,
	"DividerEnumeration": `styles_DividerEnumeration__25ygB`,
	"Scores": `styles_Scores__nre00`,
	"ScoreNumber": `styles_ScoreNumber__FSUa2`,
	"TieBreak": `styles_TieBreak__+FRun`,
	"DividerContainer": `styles_DividerContainer__55pSY`,
	"CardEditMenu": `styles_CardEditMenu__PdcAM`,
	"PlayerEditionPanel": `styles_PlayerEditionPanel__oHN2u`,
	"SelectedElement": `styles_SelectedElement__Vc-QT`,
	"SelectableElement": `styles_SelectableElement__ebYBC`,
	"TopLineScoreEditor": `styles_TopLineScoreEditor__Niiqd`,
	"BottomLineScoreEditor": `styles_BottomLineScoreEditor__Osw-n`,
	"OnlineIndicator": `styles_OnlineIndicator__-sZ5e`,
	"operatorId": `styles_operatorId__xzrgr`,
	"matchId": `styles_matchId__jR7qe`,
	"InputsId": `styles_InputsId__IzpXK`,
	"containerCart": `styles_containerCart__rYkY3`,
	"responseMessage": `styles_responseMessage__fW8Ao`,
	"DateTime": `styles_DateTime__nb1y1`,
	"Ret": `styles_Ret__0dVqM`,
	"RetActive": `styles_RetActive__PrG05`,
	"NumberMatch": `styles_NumberMatch__kLbN8`,
	"InputsPlayers": `styles_InputsPlayers__aa7Fb`,
	"ChangeStartMatch": `styles_ChangeStartMatch__TDAe+`,
	"AddPlayer": `styles_AddPlayer__yLZOw`,
	"PlayerList": `styles_PlayerList__IHFUK`
};
export default ___CSS_LOADER_EXPORT___;
